import type { AppType } from '@akagenojinro/backend/api-types';
import { hc } from 'hono/client';
import { getJwt } from './features/auth/getJwt';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

if (!apiBaseUrl) {
  throw new Error('VITE_API_BASE_URL environment variable is not set');
}

export const client = hc<AppType>(apiBaseUrl, {
  headers: async () => {
    const token = await getJwt();

    return {
      Authorization: `Bearer ${token}`,
    };
  },
});
